"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createComponentIO = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
function createComponentIO(initialValue = null) {
    const local = new rxjs_1.BehaviorSubject(initialValue);
    const subscriptions = [];
    const value$ = local.asObservable()
        .pipe(operators_1.finalize(() => {
        for (const sub of subscriptions) {
            sub.unsubscribe();
        }
    }));
    const output$ = value$.pipe(operators_1.skip(1));
    const set = (v) => local.next(v);
    const get = () => local.value;
    const subscribeTo = (ob) => {
        subscriptions.push(ob.subscribe(v => local.next(v)));
    };
    return {
        output$,
        value$,
        subscribeTo,
        set,
        get,
    };
}
exports.createComponentIO = createComponentIO;
